import React, { useEffect, useState } from 'react';
import { LOCALSTORAGE_KEYS } from 'src/app/constants';
import useConversationStarted from 'src/app/hooks/analytics/useConversationStarted';
import useGaChatClosed from 'src/app/hooks/analytics/useGaChatClosed';
import useGaChatOpened from 'src/app/hooks/analytics/useGaChatOpened';
import useAuthInit from 'src/app/hooks/useAuthInit';
import useDelayedRender from 'src/app/hooks/useDelayedRender';
import useFrameParams from 'src/app/hooks/useFrameParams';
import useSMEValidation from 'src/app/hooks/useSMEValidation';
import ChatScreen from 'src/app/views/ChatScreen/ChatScreen';
import Onboarding from 'src/app/views/Onboarding/Onboarding';
import SplashScreen from 'src/app/views/SplashScreen/SplashScreen';
import usePinWindow from '../../hooks/usePinWindow';
import useConversationHistory from 'src/app/hooks/useConversationHistory';
import useLanguageLocale from 'src/app/hooks/useLanguageLocale';
import { useOneTrustAccessibility } from 'src/app/hooks/useOneTrustAccessibility';

function Tutor() {
  const [proceed, setProceed] = useState(false);
  const isDelayed = useDelayedRender();

  useAuthInit();
  useFrameParams();
  useSMEValidation();
  useConversationHistory();
  useGaChatOpened();
  useGaChatClosed();
  useConversationStarted();
  usePinWindow();
  useLanguageLocale();
  useOneTrustAccessibility();

  useEffect(() => {
    if (localStorage.getItem(LOCALSTORAGE_KEYS.IS_RETURNING_USER)) {
      setProceed(true);
    }
  }, []);

  const isOnboarding = !isDelayed && !proceed;

  return (
    <div
      id='mainSection'
      className={
        isOnboarding ? 'h-full' : 'shadow-default p-4 rounded-lg h-full bg-white'
      }
    >
      {isDelayed ? (
        <SplashScreen />
      ) : proceed ? (
        <ChatScreen />
      ) : (
        <Onboarding onProceed={() => setProceed(true)} />
      )}
    </div>
  );
}

export default Tutor;
